<!-- 

Simple upload component to pass a csv file to the backend api
for updating real estate information.

 -->
<template>
  <div>
    <div class="row border m-2 mt-5">
      <h2 class="col-12 text-underline mt-3 mb-3">
        Update Real Estate
      </h2>

      <div class="col-md-6 filebutton p-3 link-cursor">
        <input type="file" ref="fileupload" class="form-control-file" @change="documentChange" />
      </div>

      <!-- <div class="col-6">
        <a :href="documentLink" target="blank" class="text-regular">{{fileName}}</a>
      </div> -->
  
      <div class="col">
        <div class="row justify-content-between">
          <div class="col-6">
            <button @click="uploadFile" class="btn btn-primary mt-3">
              UPLOAD
            </button>
          </div>
          <div class="col-6">
            <button @click="backupReal" class="btn btn-dark mt-3 float-right">
              BACKUP CURRENT
            </button>
          </div>
        </div>
      </div>

    </div>

    <div class="row ml-2">
    <collapse-view
      class="col mt-3 mr-3 bg-light"
      group="faq"
      :slot-id="2"  
      title="Manage Real Estate Backups">

        <div class="row">
          <div class="col">

            <div v-for="backup in backups" :key="backup">
              <div class="row align-items-center mb-3">
                <div class="col-auto">
                  <button @click="restoreReal(backup)" class="btn btn-success mt-3 float-left">
                    RESTORE
                  </button>
                </div>

                <div class="col-auto float-left">
                  {{backup}}
                </div>
              </div>
            </div>

            <div class="row justify-content-between">
              <div class="col-6">
                <button @click="listBackups" class="btn btn-dark mt-3">
                  SHOW AVAILABLE BACKUPS
                </button>
              </div>

              <div class="col-6">
                
              </div>
            </div>

          </div>
        </div>

    </collapse-view>
    </div>

    <!-- modal window for verifying update submission -->
    <modal-window
    text-value="Real Estate Updated" 
    v-show="updateModalOpened"
    v-on:close-modal="closeUpdateModal"
    v-on:yes-click="closeUpdateModal"
    ></modal-window>

  </div>
</template>

<script>

import axios from 'axios'
import CollapseView from '@/components/display-utils/CollapseView.vue'
import ModalWindow from '@/components/display-utils/ModalWindow.vue'

export default {
  components: {
    CollapseView,
    ModalWindow
  },
  data () {
    return {
      documentName: "",
      fileLocation: "",
      fileData: null,
      backups: [],
      updateModalOpened: false
    }
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {
    uploadFile: function() {
      //set local
      let local = this

      this.packageData()

      //open notification window
      this.updateModalOpened = true

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/real/update',
          data: local.fileData,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'multipart/form-data',
                    'User-Token': local.$helpers.getToken()} //only needed for admin tasks
        })
        .then(function (res) {
          local.uploadSuccess() //notify user of save
        })
        .catch(function (error) {
          //upload failed, do a popup
        });
    },

    packageData: function() {
      const formData = new FormData()
      formData.append("file", this.fileLocation)
      formData.append("title", this.documentName)
      this.fileData = formData
    },

    backupReal: function() {
      let local = this

      axios({
        method: 'get',
        url: this.$helpers.api() + '/admin/real/backup',
        headers: {'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'multipart/form-data',
                  'User-Token': local.$helpers.getToken()} //only needed for admin tasks
      })
      .then(function (res) {
        local.uploadSuccess() //notify user of save
      })
      .catch(function (error) {
        //upload failed, do a popup
      });
    },

    restoreReal: function(data) {
      let local = this
      let restore = {}
      restore.name = data

      axios({
        method: 'post',
        url: this.$helpers.api() + '/admin/real/restore',
        data: restore,
        headers: {'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'multipart/form-data',
                  'User-Token': local.$helpers.getToken()} //only needed for admin tasks
      })
      .then(function (res) {
        local.uploadSuccess() //notify user of save
      })
      .catch(function (error) {
        //upload failed, do a popup
      });
    },

    listBackups: function() {
      let local = this

      axios({
        method: 'get',
        url: this.$helpers.api() + '/admin/real/backup/list',
        headers: {'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'multipart/form-data',
                  'User-Token': local.$helpers.getToken()} //only needed for admin tasks
      })
      .then(function (res) {
        local.backups = res.data
      })
      .catch(function (error) {
        //upload failed, do a popup
      });
    },

    documentChange: function(event) {
      if (!event.target.files) {
        return
      }

      //set file location on client system
      this.fileLocation = event.target.files[0]
      this.documentName = event.target.files[0].name
    },

    closeUpdateModal: function() {
      this.updateModalOpened = false
    },

    uploadSuccess: function() {
      //
    }
  }
}

</script>

<style>
</style>